import React,{ useContext } from 'react';

const ChildModuleContext = React.createContext(null);

export default ChildModuleContext;

export const useChildModuleContext = () =>  useContext(ChildModuleContext) ;

